import { create } from 'zustand';

export interface VendorDetailDialogTarget {
  vendorId: number;
  vendorName?: string | null;
  vendorCompany?: string | null;
  /** Which tab to land on when opening. */
  tab?: 'pos' | 'sales';
}

interface VendorDetailDialogState {
  open: boolean;
  target: VendorDetailDialogTarget | null;
  openVendorDetail: (t: VendorDetailDialogTarget) => void;
  closeVendorDetail: () => void;
}

export const useVendorDetailDialogStore = create<VendorDetailDialogState>((set) => ({
  open: false,
  target: null,
  openVendorDetail: (t) => set({ open: true, target: t }),
  closeVendorDetail: () => set({ open: false, target: null }),
}));

export function openVendorDetail(t: VendorDetailDialogTarget) {
  useVendorDetailDialogStore.getState().openVendorDetail(t);
}

export function closeVendorDetail() {
  useVendorDetailDialogStore.getState().closeVendorDetail();
}
